import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Checkbox, Form, Input, TimePicker
} from 'antd';
import moment from 'moment';
import _ from 'lodash';
import ExtendedSelect from 'components/extendedSelect/extended-select';
import settings from 'settings';
import { convertToSelect, getKey, getLabel } from 'library/helpers';
import { list } from 'actions';
import REDUCER_KEY from 'reducers/reducer.keys';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;

const mapStateToProps = state => ({
  routes: state.api.travelRoutes.data.results
});

const mapDispatchToProps = dispatch => ({
  loadRoutes(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }
    filters.push({
      id: 'active',
      value: true
    });
    return dispatch(list(REDUCER_KEY.travelRoutes.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  }
});

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const {
    active, carrier, route, referenceNumber, departure_time, arrival_time
  } = dataSource;

  return {
    carrier: Form.createFormField({ value: carrier }),
    route: Form.createFormField({ value: convertToSelect(route) }),
    referenceNumber: Form.createFormField({ value: referenceNumber }),
    departure_time: Form.createFormField({ value: departure_time ? moment(departure_time, 'HH:mm') : undefined }),
    arrival_time: Form.createFormField({ value: arrival_time ? moment(arrival_time, 'HH:mm') : undefined }),
    active: Form.createFormField({ value: active })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, checkboxFormItemLayout, dataSource, inputFormItemLayout, form, loadRoutes, routes
}) => {
  const { getFieldDecorator } = form;
  const {
    active, carrier, route, reference_number, departure_time, arrival_time
  } = dataSource;
  const readonly = !canAdmin;
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Route">
        {getFieldDecorator('route', {
          initialValue: route,
          rules: [{
            required: true,
            message: 'Please enter the Route'
          }]
        })(
          <ExtendedSelect
            placeholder="Select Route"
            dataSource={routes}
            optionKey={getKey}
            optionLabel={getLabel}
            disabled={readonly}
            onFocus={loadRoutes}
            onSearch={loadRoutes}
          />
        )}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Reference">
        {getFieldDecorator('reference_number', {
          initialValue: reference_number,
          rules: [{
            required: true,
            message: 'Please enter the Reference'
          }]
        })(<Input maxLength={255} disabled={readonly} />)}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Carrier">
        {getFieldDecorator('carrier', {
          initialValue: carrier
        })(<Input maxLength={255} disabled={readonly} />)}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Departure Time">
        {getFieldDecorator('departure_time', {
          initialValue: moment(departure_time, 'HH:mm'),
          rules: [
            {
              required: true,
              message: 'Please enter the Departure Time.'
            }
          ]
        })(<TimePicker format="HH:mm" disabled={readonly} />)}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Arrival Time">
        {getFieldDecorator('arrival_time', {
          initialValue: moment(arrival_time, 'HH:mm'),
          rules: [
            {
              required: true,
              message: 'Please enter the Arrival Time.'
            }
          ]
        })(<TimePicker format="HH:mm" disabled={readonly} />)}
      </FormItem>
      <FormItem {...checkboxFormItemLayout}>
        {
          getFieldDecorator('active', {
            initialValue: active,
            valuePropName: 'checked'
          })(
            <Checkbox disabled={readonly}>
              Active
            </Checkbox>
          )
        }
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  loadRoutes: PropTypes.func,
  routes: PropTypes.array,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  loadRoutes() {
  },
  routes: [],
  onFieldsChange() {
  },
  onValuesChange() {
  }
};

const ConnectedFormInput = connect(mapStateToProps, mapDispatchToProps)(FormInput);

const LegFormInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(ConnectedFormInput));

export default LegFormInput;
